import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { Link } from 'react-router-dom'

const Profiledetails = ({ isActiveTab, data, isFetching }) => {
    return (
        <div className={`ContainerTabForAllTabData tabWrapper ${isActiveTab && 'active'}`}>
            <div className="Headingforallheader">
                <div className="flex-between w-100">
                    <h2 className="heading-2">Profile Details</h2>
                </div>
            </div>

            <div className="border-btm w-100"></div>

            <div className="bodyDataForallUserdata Adfixwidthalldata">
                <div className="profileDetailsWrap">
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : "First Name"}
                        </div>
                        <div className="profileData AdAnssetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : data?.firstName ? data?.firstName : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : "Last Name"}
                        </div>
                        <div className="profileData AdAnssetwidth">
                        {isFetching ? <Skeleton width={"100px"} /> : data?.lastName ? data?.lastName : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : "Phone Number"}
                        </div>
                        <div className="profileData AdAnssetwidth">
                        {isFetching ? <Skeleton width={"130px"} /> : data?.mobileNumber ? data?.mobileNumber : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : "Email"}
                        </div>
                        <div className="profileData AdAnssetwidth">
                        {isFetching ? <Skeleton width={"200px"} /> : data?.email ? data?.email : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : "Linkedin"}
                        </div>
                        <div className="profileData AdAnssetwidth">
                        {isFetching ? <Skeleton width={"200px"} /> : data?.linkedin ? <a href={data?.linkedin.slice(0,4) === "http" ? data?.linkedin : "https://" + data?.linkedin} className='linkedintext' target='_blank' rel='noreferrer' >{data?.linkedin}</a> : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"200px"} /> : "Qualification Level"}
                        </div>
                        <div className="profileData AdAnssetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : data?.profession?.title === "work" ? 'Working Professional' : 'Student'}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"210px"} /> : data?.profession?.title === "work" ? "Professional Domain" : "Qualification Domain"}
                        </div>
                        <div className="profileData AdAnssetwidth">
                            {isFetching ? <Skeleton width={"130px"} /> : data?.profession?.company ? data?.profession?.company : " ---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"180px"} /> : data?.profession?.title === "work" ? "Working Experience" : "Year of Study"}
                        </div>
                        <div className="profileData AdAnssetwidth">
                            {isFetching ? <Skeleton width={"160px"} /> : data?.profession?.yrsOfExp ? `${data?.profession?.yrsOfExp}+ years` : '---' }
                        </div>
                    </div>

                </div>

            </div>

        </div>
    )
}

export default Profiledetails
